import useGroupProduct from '../../../../../hooks/useGroupProduct';

import { DealProduct, GroupKey, GroupMember } from '../../../../../types';

import OptionItemList from './OptionItemList';
import ProductInfoItemWrapper from '../../ProductInfoItemWrapper';
import DealProductStepper from '../../../../../shared/DealProductStepper';

interface Props {
  productNo: number;
  groupKeys: GroupKey[];
  groupMembers: GroupMember[];
  dealProduct: DealProduct;
}

export default function OptionContent({ productNo, groupKeys, groupMembers, dealProduct }: Props) {
  const { optionList, changeOptionItem } = useGroupProduct({ productNo, groupKeys, groupMembers });

  return (
    <>
      {optionList.map((option) => (
        <OptionItemList
          key={option.title}
          title={option.title}
          descriptionType={option.descriptionType}
          options={option.options}
          selectedOption={option.selectedOption}
          changeOptionItem={changeOptionItem}
        />
      ))}
      <ProductInfoItemWrapper title="구매수량" titleLineHeight={30}>
        <DealProductStepper dealProduct={dealProduct} />
      </ProductInfoItemWrapper>
    </>
  );
}
